/*
 * Import common js to use common function in this javascript file
 */
import { deleteConfirmationAlert, commonClockTimepicker, commonDatepicker, select2Dropdown } from "./common";
import { searchByTableColumns } from "./common";



/**
 * Guest store
 */
window.$(document).on('click', '.saveGuest', function (e) {
    e.preventDefault();
    window.$(".error").html('');
    window.toastr.remove();
    window.$('.saveGuest').attr('disabled', 'disabled');
    var code = $(".iti__selected-dial-code");
    // console.log(code[0].innerHTML)
    window.axios({
        method: "post",
        url: window.$(".guestForm").attr('action'),
        data: window.$(".guestForm").serialize()+ "&phone_code_number="+code[0].innerHTML,
    })
        .then(function (response) {
            window.toastr.success(response.data.message, response.statusText);
            // if saveGuest trigger in popup, no need to redirect, just toggle modal
            if (window.$(".reservationWrapper").length !== 1) {
                setTimeout(function () {
                    window.location = response.data.redirectTo;
                }, 1000);
            } else {
                window.$('#add_new_guest').modal('toggle');
                // var modal = document.getElementById("create-guest-modal");
                // modal.style.display = "none";
                // Show guest data as autocomplete
                window.$('#guest_id').val(response.data.data.guest_id);
                window.$('#guest_name').text(response.data.data.name);
                window.$('#guest_email').text(response.data.data.email);
                window.$('#guest_phone_number').text(response.data.data.phone_number);
                window.$('.guest_information').removeAttr('hidden');
                window.$('.guest_information').removeClass('d-none');
            }
        })
        .catch(function (error) {
            window.$('.saveGuest').removeAttr('disabled');
            if (error.response.status == 400) {
                window.$.each(error.response.data, function (key, value) {
                    window.$('#' + key + '-error').text(value[0]);
                });
            } else if (error.response.status == 500) {
                window.toastr.error(error.response.data.message, error.response.statusText);
            } else if (error.response.status == 409) {
                window.toastr.warning(error.response.data.message, error.response.statusText);
            }
        });
    return false;
});

/**
 * Guest update
 */
window.$(document).on('click', '.updateGuest', function (e) {
    e.preventDefault();
    window.$(".error").html('');
    window.toastr.remove();
    window.$('.updateGuest').attr('disabled', 'disabled');
    var code = window.$(".iti__selected-dial-code").text();

    window.axios({
        method: "PUT",
        url: window.$(".guestUpdateForm").attr('action'),
        data: window.$(".guestUpdateForm").serialize()+ "&phone_code_number="+code,
    })
        .then(function (response) {
            window.toastr.success(response.data.message, response.statusText);
            // if saveGuest trigger in popup, no need to redirect, just toggle modal
            if (window.$(".reservationWrapper").length !== 1) {
                setTimeout(function () {
                    window.location = response.data.redirectTo;
                }, 1000);
            } else {
                window.$('#add_new_guest').modal('toggle');

                // var modal = document.getElementById("create-guest-modal");
                // modal.style.display = "none";
                // Show guest data as autocomplete
                window.$('#guest_id').val(response.data.data.guest_id);
                window.$('#guest_name').text(response.data.data.name);
                window.$('#guest_email').text(response.data.data.email);
                window.$('#guest_phone_number').text(response.data.data.phone_number);
                window.$('.guest_information').removeAttr('hidden');
                window.$('.guest_information').removeClass('d-none');
            }
        })
        .catch(function (error) {
            window.$('.updateGuest').removeAttr('disabled');
            if (error.response.status == 400) {
                window.$.each(error.response.data, function (key, value) {
                    window.$('#' + key + '-error').text(value[0]);
                });
            } else if (error.response.status == 500) {
                window.toastr.error(error.response.data.message, error.response.statusText);
            }
            else if (error.response.status == 409) {
                window.toastr.error(error.response.data.message, error.response.statusText);
            }

        });
    return false;
});

/**
 * Guest table listing
 */
let guestDisplayRecords;
let guestTotalRecords;
var table = window.$('.guestTable').DataTable({
    "oLanguage": DATATABLE_LANGUAGE_OPTIONS,
    "aLengthMenu": DATATABLE_MENU_LENGTH_OPTIONS,
    processing: true,
    serverSide: true,
    "ajax": {
        "url": window.$(".guestTable").attr('link'),
        "type": "GET",
        "data": function (d) {
            d.iTotalDisplayRecords = guestDisplayRecords;
            d.iTotalRecords = guestTotalRecords;
        }
    },
    "initComplete": function (settings, res) {
        guestDisplayRecords = res.iTotalDisplayRecords;
        guestTotalRecords = res.iTotalRecords;
    },
    columns: [
        { data: 'id', name: 'id', "visible": false, },
        { data: 'reservations', name: 'reservations', width:'10%' },
        { data: 'first_name', name: 'first_name' },
        { data: 'last_name', name: 'last_name' },
        { data: 'email', name: 'email' },
        { data: 'phone_number', name: 'phone_number', width:'14%' },
        { data: 'guest_since', name: 'guest_since', width:'8%' },
        { data: 'newsletter', name: 'newsletter', orderable: false, className: "status", width:'8%' },
        { data: 'action', name: 'action', orderable: false, searchable: false, width:'6%' },
    ],
});

/**
 * Delete Guest
 */
window.$(document).on('click', '.guestTable .deleteGuest', function (e) {
    var currentObj = window.$(this);
    // Call method for delete confirmation
    var promise = deleteConfirmationAlert();
    promise.then(function (result) {
        // If confirmation true, do action for delete
        var myTable = $(".guestTable").DataTable({
            bRetrieve: true,
            ajax: window.$(".guestTable").attr('link')
        });
        e.preventDefault();
        window.axios({
            method: "DELETE",
            url: currentObj.attr('link')
        })
            .then(function (response) {
                myTable.ajax.reload();
                window.toastr.success(response.data.message, response.statusText);
            })
            .catch(function (error) {
                window.toastr.error(error.response.data.message, error.response.data.statusText);

            });
        return false;

    }).catch(function (err) {
        console.log(err);
        return false;
    });

});

// change newsletter of guest tag
window.$(document).on('click', '.guestTable .newsletter_checkbox', function (e) {

    window.$(".error").html('');
    window.toastr.remove();

    //var id = window.$(this).closest("tr").attr('id');
    var id = window.$(this).attr('id');
    if (typeof id !== "undefined" && id !== '') {
        var newsletter = (window.$(this).is(':checked')) ? 'on' : 'off';

        var queryString = '/' + id;

        window.axios({
            method: queryString == '' ? "post" : "put",
            url: window.$(".guestTable").attr('link') + queryString,
            data: {
                'id': id,
                'newsletter': newsletter,
                'update_newsletter': true
            }
        })
            .then(function (response) {
                window.toastr.success(response.data.message, response.statusText);
            })
    }
});


// Disabled/hide next prev arrow for DOB datepicker
window.$(".datepicker-dob").datetimepicker({
    timepicker: false,
    format: DATE_FORMAT,
    dayOfWeekStart: 1,
    yearStart: 1900,
    yearEnd: new Date().getFullYear(),
    monthStart: 0,
    monthEnd: new Date().getMonth(),
    maxDate: 0,
    onClose: function (dateText, inst) {
        var date = moment(dateText).format(DATE_FORMAT_GUEST);
        window.$(inst).val(date);
    },
    onChangeYear: function (dateText, inst) {
        var date = moment(dateText).format(DATE_FORMAT_GUEST);
        window.$(inst).val(date);
    },
    onChangeMonth: function (dateText, inst) {
        var date = moment(dateText).format(DATE_FORMAT_GUEST);
        window.$(inst).val(date);
    }
}).focus(function () {
    window.$(".xdsoft_prev").hide();
    window.$(".xdsoft_next").hide();
});


window.$(document).ready(function () {
    // Setup - add a text input to each footer cell
    var excluded_columns = [1, 7, 8];
    searchByTableColumns(table, '.guestTable', excluded_columns);

    // Create guest view
    if (window.$("#create_guest").length == 1) {
        window.axios({
            method: "post",
            url: window.$("#create_guest").attr('data-url'),
            data: {}
        })
            .then(function (response) {
                Promise.resolve(1).then(function resolve() {
                    commonDatepicker();
                    select2Dropdown();
                });
                window.$('#create_guest').html(response.data);

            })
    }

    // Edit guest view
    if (window.$("#edit_guest").length == 1) {
        window.axios({
            method: "post",
            url: window.$("#edit_guest").attr('data-url'),
            data: {
                'id': window.$("#edit_guest").attr('data-id')
            }
        })
            .then(function (response) {
                Promise.resolve(1).then(function resolve() {
                    commonDatepicker();
                    select2Dropdown();
                });
                window.$('#edit_guest').html(response.data);
            })
    }
});
window.$(document).ajaxComplete(function () {
    window.$('[data-toggle="tooltip"]').tooltip()
});
window.$(document).on('click', '#guestReservation', function (e) {
    e.preventDefault();
    var url = $(this).attr('resURL');
    window.location = url;
});
// ALLOW DATE TO CLEAR
window.clearDate = function (e) {
    var charCode = e.keyCode || e.which;
    if (charCode == 8 || charCode == 46) {
        return true;
    }
    return false;
}